<template>
  <AtomSpinner
    v-if="isSignatureUrlLoading"
    class="mx-auto flex min-h-[60vh] items-center justify-center"
    data-cy="contract-signature-loader"
  />
  <div
    v-show="!isSignatureUrlLoading"
    id="iframe-container"
    class="w-full h-[calc(100vh-110px)]"
    data-cy="contract-signature-iframe-container"
  />
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { onMounted } from 'vue';

import { useSubscriptionStore } from '@/stores';

import { YouSignResponseStatus } from '@/types/yousign.type';

import { isYousignSandbox } from '@/service/env';

const subscriptionStore = useSubscriptionStore();
const { getCurrentSubscriptionId, isSignatureUrlLoading } = storeToRefs(subscriptionStore);

const emit = defineEmits<{
  updateYouSignStatus: [status: YouSignResponseStatus];
}>();

const initYouSign = async () => {
  try {
    const signatureUrl = await subscriptionStore.fetchContractSignatureUrl();

    const yousign = new Yousign({
      signatureLink: isYousignSandbox.value
        ? `${signatureUrl}&disable_domain_validation=true`
        : signatureUrl,
      iframeContainerId: 'iframe-container',
      isSandbox: isYousignSandbox.value,
    });

    yousign.onSuccess(() => {
      emit('updateYouSignStatus', YouSignResponseStatus.SUCCESS);
    });

    yousign.onError(() => {
      emit('updateYouSignStatus', YouSignResponseStatus.ERROR);
    });
  } catch {
    emit('updateYouSignStatus', YouSignResponseStatus.ERROR);
  }
};

onMounted(() => {
  if (getCurrentSubscriptionId.value) {
    initYouSign();
  }
});
</script>

<style lang="scss" scoped>
:deep(iframe) {
  width: 100%;
  height: 100%;
}
</style>
